import { FormPrintReceiptPos } from 'front-office/view-models/print-receipt-pos-page';
import { DateTime } from 'luxon';
import { CertificatesIssued, RequestPrintReceiptPos } from 'shell/models/request-print-receipt-pos';

export const transformerPrintReceiptPosRequest = (
  values: FormPrintReceiptPos
): RequestPrintReceiptPos => {
  let totale = 0;

  const certificatiRilasciati: CertificatesIssued[] = (values?.selected || [])?.map((item) => {
    totale += Number.parseFloat(item?.amount || '');

    return {
      tipoCertificato: item?.type || undefined,
      importo: item?.amount || undefined,
      numeroServizio: item?.number || undefined,
      modalitaPagamento: item?.modality || undefined,
    };
  });

  return {
    dataRicevuta: DateTime.now().toFormat('dd/MM/yyyy'),
    nomeOperatore: (values?.list && values?.list[0]?.operator) || undefined,
    certificatiRilasciati,
    totale,
  };
};
